// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"src-pages-business-components-BusinessProtocol-AuthProtocol-HLProtocolContent-__index__paragraph--3QE6w"};